export const useQuestionTypeOptions = () => { 
    return [{name:"SCORE", answer:false}, {name:"TEXTAREA", answer:false}, {name:"CHECKBOX", answer:false}, {name:"NPS", answer:false}, {name:"RADIO", answer:true}, {name:"MULTISELECT", answer:true}];
};
